import React from 'react';
import PropTypes from 'prop-types';

const ImportMainDivisionList = ({ divisions, selectedDivision, onDivisionSelect }) => (
  <ul>
    { divisions.map((division, index) => (
      <li key={ division } className={ selectedDivision === index ? 'selected' : '' } onClick={ () => onDivisionSelect(index) }>
        { division }
      </li>
    ))}
  </ul>
);

ImportMainDivisionList.propTypes = {
  selectedDivision: PropTypes.number,
  divisions: PropTypes.arrayOf(PropTypes.string).isRequired,
  onDivisionSelect: PropTypes.func
};

ImportMainDivisionList.defaultProps = {
  selectedDivision: 0,
  onDivisionSelect: () => null
};

export default ImportMainDivisionList;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/importMainDivisionList/ImportMainDivisionList.js